import { expect } from 'chai';
import { createRequestObject } from './request';
import { createResponseObject } from './response';

export const createNgObject = (context, type) => {
  const variables = new Map(Object.entries(context.variables || {}));
  const environment = new Map(Object.entries(context.environment || {}));
  const testResults = [];
  const logs = [];

  const console = {
    log: (...args) => logs.push({ type: 'log', args: Array.from(args) }),
    error: (...args) => logs.push({ type: 'error', args: Array.from(args) }),
    warn: (...args) => logs.push({ type: 'warn', args: Array.from(args) }),
    info: (...args) => logs.push({ type: 'info', args: Array.from(args) })
  };

  const testFunction = (name, fn) => {
    try {
      fn();
      testResults.push({ name, status: 'pass' });
    } catch (error) {
      testResults.push({ name, status: 'fail', error: error.message });
    }
  };

  const ng = {
    variables: {
      set: (key, value) => variables.set(key, value),
      get: (key) => variables.get(key),
      unset: (key) => variables.delete(key),
      has: (key) => variables.has(key),
      toObject: () => Object.fromEntries(variables)
    },
    
    environment: {
      set: (key, value) => environment.set(key, value),
      get: (key) => environment.get(key),
      unset: (key) => environment.delete(key),
      has: (key) => environment.has(key),
      toObject: () => Object.fromEntries(environment)
    },
    
    test: testFunction,
    expect: expect,
    console: console
  };

  if (type === 'pre-request') {
    ng.request = createRequestObject(context);
  } else if (type === 'post-response') {
    ng.response = createResponseObject(context);
  }

  return { ng, logs, testResults, variables, environment, modifiedContext: context };
};
